"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ProductFlag_1 = require("../../../product/model/ProductFlag");
/**
 * Data transfer object for sizes of internal product
 *
 * @author RV
 */


var ProductSizesDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductSizesDTO, _DomainObject_1$Domai);

  /**
   *
   * @param internalProductId
   * @param flags of internal products
   * @param sizeCharger from {@link CompetitorProductBinding}
   * @param sizeRatio from {@link CompetitorProductBinding}
   * @param packageSize of internal product
   */
  function ProductSizesDTO(internalProductId, flags, sizeCharger, sizeRatio, packageSize) {
    var _this;

    _classCallCheck(this, ProductSizesDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSizesDTO).call(this));
    _this.internalProductId = internalProductId;
    _this.flags = flags;
    _this.sizeCharger = sizeCharger;
    _this.sizeRatio = sizeRatio;
    _this.packageSize = packageSize;
    return _this;
  }

  return ProductSizesDTO;
}(DomainObject_1.DomainObject);

exports.ProductSizesDTO = ProductSizesDTO;

ProductSizesDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductSizesDTO.name);
  return {
    internalProductId: builder.str('internalProductId'),
    flags: builder.flags('flags', ProductFlag_1.ProductFlag),
    sizeCharger: builder.opt(builder.bigNum('sizeCharger')),
    sizeRatio: builder.opt(builder.bigNum('sizeRatio')),
    packageSize: builder.data('packageSize', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    })
  };
}();